import { Link } from 'react-router';
import React, { PropTypes } from 'react';
import validate from 'validate.js';

const LogoutLink = ({
    onClick,
    user
  }) => (
  <li style={{ float: 'right' }}>
    <Link to="/users/profile" style={{color: 'white', marginRight: '15px'}}>
      {user && `${validate.capitalize(user.first_name)} ${validate.capitalize(user.last_name)} `}
    </Link>
    <a href="javascript:void(0)" onClick={onClick}>
      Logout
    </a>
  </li>
)

LogoutLink.PropTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
}

export default LogoutLink;



/** WEBPACK FOOTER **
 ** ./src/components/Navbar/LogoutLink.jsx
 **/